import React from 'react';
import { ACCOUNTS_STATUS_LIST, capitalizeWords } from '../../../../../utils/constant';
import arrow from '../../../../../assets/image/arrowD.svg';

export default function AccountingDropdownComponent({
	params,
	toggle,
	isAccountOpenDropdown,
	setParams,
	type,
	list,
}) {
	return (
		<div className="accounting-dropdown-container d-flex align-items-center">
			<div data-testid={`account-status-select-button`} onClick={toggle}>
				<div className="d-flex align-items-center justify-content-between">
					<div className="accounting-dropdown fs-4 fw-semibold px-3 py-2">
						{params.status === '' || params.status === null
							? `All ${type}`
							: capitalizeWords(params.status)}
						<span
							style={{
								transform: isAccountOpenDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
							}}
						>
							<img
								src={arrow}
								alt=""
							/>
						</span>
					</div>
				</div>
				{isAccountOpenDropdown && (
					<div className="accounting-dropdown-options-container">
						{list.map((option) => (
							<div
								key={option.key}
								data-testid={`account-${option.label}-select`}
								className="p-2 cursor-pointer"
								onClick={() => {
									setParams((prev) => ({
										...prev,
										status: option.key,
									}));
								}}
							>
								{option.label}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
}
